import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface OriginatorListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    name?: string;
}

const defaultFilters: OriginatorListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "name",
    sortOrder: "asc",
    name: ""
};

export const useOriginatorListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<OriginatorListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<OriginatorListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: OriginatorListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: OriginatorListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: OriginatorListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setName = (name?: string): void => {
        setFilters((prevFilters: OriginatorListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setName,
        setPage,
        setPageSize,
        setSort,
        clearFilters
    };
};
